

import { Component, Injector, OnInit } from '@angular/core';
import { RunningType, ScheduleConstants, ScheduleMethodType } from 'tnx-admin-service/schedulejob/constants';
import { ScheduleJobService } from 'tnx-admin-service/schedulejob/services';
import {
    ComponentContextService, DataFormBase, DropdownControlSchema, EventData, FormSchemaBase, RadioButtonListControlSchema, TextAreaControlSchema, TextControlSchema
} from 'tnx-shared';

@Component({
    selector: 'schedulejob-form',
    templateUrl: './schedulejob-form.component.html',
    styleUrls: ['./schedulejob-form.component.scss'],
    providers: [ComponentContextService],
})
export class ScheduleJobFormComponent extends DataFormBase implements OnInit {

    constructor(
        protected _injector: Injector,
        private _scheduleJobService: ScheduleJobService
    ) {
        super(_injector);
    }

    ngOnInit() {
        super.ngOnInit();
        this.setting.baseService = this._scheduleJobService;

        this.setting.schema = <FormSchemaBase[]>[
            new DropdownControlSchema({
                label: 'Trạng thái',
                fullLabel: 'Trạng thái',
                field: 'status',
                displayField: 'label',
                valueField: 'value',
                mdWidth: 12,
                required: true,
                dataSource: ScheduleConstants.ScheduleMethodTypeDataSource,
                disabled: false,
                defaultValue: ScheduleMethodType.Stop,
                // hiddenCheck: () => {
                // 	return this._isFormAddNew();
                // },
            }),
            new TextControlSchema({
                label: 'Mã công việc',
                fullLabel: 'Mã công việc',
                field: 'codeJob',
                mdWidth: 12,
                required: true,
            }),
            new TextControlSchema({
                label: 'Tên công việc',
                fullLabel: 'Tên công việc',
                field: 'name',
                mdWidth: 12,
                required: true
            }),
            new TextAreaControlSchema({
                label: 'Mô tả',
                fullLabel: 'Mô tả',
                field: 'description',
                mdWidth: 6
            }),
            new TextAreaControlSchema({
                label: 'Dữ liệu gửi kèm (json)',
                fullLabel: 'Dữ liệu gửi kèm (json)',
                field: 'data',
                mdWidth: 6
            }),
            new TextControlSchema({
                label: 'Topic RabbitMQ',
                fullLabel: 'Topic RabbitMQ',
                field: 'replyTo',
                mdWidth: 12,
                required: true
            }),
            new RadioButtonListControlSchema({
                field: 'multipleRunning',
                label: 'Hình thức chạy',
                fullLabel: 'Chạy tuần tự: chỉ cho phép 1 Lịch trình chạy cùng lúc / Chạy song song: cho phép nhiều Lịch trình chạy cùng lúc',
                defaultValue: RunningType.Multiple,
                dataSource: ScheduleConstants.RunningTypeDataSource,
                valueField: 'value',
                displayField: 'label',
                required: true,
                mdWidth: 6
            }),
            new TextControlSchema({
                label: 'Thời gian timeout (giây)',
                fullLabel: 'Thời gian timeout (giây)',
                field: 'timeout',
                dataFormat: 'number',
                required: true,
                mdWidth: 6,
                min: 1
            }),


        ];
    }

    async onFormInitialized(formEvent: EventData) {
        // tiền xử lý dữ liệu (ví dụ tổng hợp datasource), trước khi gọi api get detail
        if (this._isFormAddNew()) {
            this.formControls['status'].disabled = true;
            this.model.data.status = ScheduleMethodType.Stop;
        }
    }

    async modifyDetailData(data) {
        // xử lý dữ liệu lấy từ get detail về
    }

    onBeforeSave() {
        // trước khi lưu
    }
}
